// 当同时需要修改多个mutation时候 可以用action封装起来
// 引入mutations-types
// import { getUserMenu } from '@/api/common'
import router from '@/router'
import { get } from '@common/http'
import { getSecMeauList } from '@/common/utils'
const actions = {
  setAllIndex({ commit }) {
    commit('set_navindex', '')
    commit('set_second', '')
  },
  getMenu({ commit }) {
    return new Promise(resolve => {
      get(`/user/permission/${window.localStorage.getItem('tenantId')}`).then(res => {
        // user/permission
        let roudata = router.options.routes
        // console.log(roudata, "roudata");
        let listData = roudata.filter(item =>
          res.data.some(ele => ele.resourceCode == item.meta.resourceCode)
        )
        getSecMeauList(listData, res.data)

        let index = 0
        let localNo = localStorage.getItem('navindex')
        if (listData.length == 0) {
          commit('set_navindex', index)
          commit('set_listDatas', listData)
          commit('set_permissionlist', res.data)
          resolve()
        }
        if (localNo) {
          index = localNo
        } else {
          index = listData[0].meta.No
        }

        let rootRouter = 1

        for (let i = 0; i < listData.length; i++) {
          if (listData[0].path !== '/') {
            rootRouter = 0
          }
          if (listData[i].path !== '/' && listData[i].children) {
            for (let j = 0; j < listData[i].children.length; j++) {
              if (listData[i].children[j].meta.second == true) {
                console.log(listData[i].redirect.name, listData[i].children[j].name)
                listData[i].redirect.name = listData[i].children[j].name
                break
              }
            }
          }
        }

        console.log(rootRouter, 'rootRouter')
        listData = listData.filter(item => {
          if (item.name === 'market') {
            item.children.splice(1, item.children.length - 1)
          }
          return item
        })
        localStorage.setItem('rootRouter', rootRouter)
        localStorage.setItem('listData', JSON.stringify(listData))

        commit('set_navindex', index)
        commit('set_listDatas', listData)
        commit('set_permissionlist', res.data)
        resolve()
      })
    })
  },
  clearMenu({ commit }) {
    localStorage.setItem('listData', '[]')
    commit('set_claerListDatas', [])
  }
}
export default actions

// export const setAllIndex = function ({ commit }) {
//     commit('set_navindex', '')
//     commit('set_second', '')
// }

// export const getMenu = function ({ commit }) {
//     return new Promise((resolve, reject) => {
//         get(`/user/permission/${window.localStorage.getItem('tenantId')}`).then(
//             res => {
//                 console.log('getMeun执行了')
//                 // user/permission
//                 let roudata = router.options.routes
//                 // console.log(roudata, "roudata");
//                 let listData = roudata.filter(item =>
//                     res.data.some(
//                         ele => ele.resourceCode == item.meta.resourceCode
//                     )
//                 )
//                 // console.log(listData, "getMenu");

//                 getSecMeauList(listData, res.data)

//                 let index = 0
//                 let localNo = localStorage.getItem('navindex')
//                 if (listData.length == 0) {
//                     commit('set_navindex', index)
//                     commit('set_listDatas', listData)
//                     commit('set_permissionlist', res.data)
//                     resolve()
//                 }
//                 if (localNo) {
//                     index = localNo
//                 } else {
//                     index = listData[0].meta.No
//                 }

//                 console.log('listData', listData)
//                 let rootRouter = 1

//                 for (let i = 0; i < listData.length; i++) {
//                     if (listData[0].path !== '/') {
//                         rootRouter = 0
//                     }
//                     if (listData[i].path !== '/' && listData[i].children) {
//                         for (let j = 0; j < listData[i].children.length; j++) {
//                             if (listData[i].children[j].meta.second == true) {
//                                 console.log(listData[i].redirect.name, listData[i].children[j].name)
//                                 listData[i].redirect.name =
//                                     listData[i].children[j].name
//                                 break
//                             }
//                         }
//                     }
//                 }

//                 console.log(rootRouter, 'rootRouter')
//                 listData = listData.filter(item => {
//                     if (item.name === 'market') {
//                         item.children.splice(1, item.children.length - 1)
//                     }
//                     return item
//                 })
//                 localStorage.setItem('rootRouter', rootRouter)
//                 localStorage.setItem('listData', JSON.stringify(listData))

//                 commit('set_navindex', index)
//                 commit('set_listDatas', listData)
//                 commit('set_permissionlist', res.data)
//                 resolve()
//             }
//         )
//     })
// }

// export const clearMenu = function ({ commit }) {
//     localStorage.setItem('listData', '[]')
//     commit('set_claerListDatas', [])
// }



// WEBPACK FOOTER //
// ./src/store/actions.js